export default __webpack_public_path__ + "static/media/mons2.6538312e.jpg";